var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIntegration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.72656H13.125C12.6418 2.72656 12.25 3.11831 12.25 3.60156V7.97656C12.25 8.45981 12.6418 8.85156 13.125 8.85156H17.5C17.9832 8.85156 18.375 8.45981 18.375 7.97656V3.60156C18.375 3.11831 17.9832 2.72656 17.5 2.72656Z",
    stroke: "#67768E",
    strokeWidth: 1.03313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 18.4766V7.10156C8.75 6.8695 8.65781 6.64694 8.49372 6.48284C8.32962 6.31875 8.10706 6.22656 7.875 6.22656H3.5C3.26794 6.22656 3.04538 6.31875 2.88128 6.48284C2.71719 6.64694 2.625 6.8695 2.625 7.10156V17.6016C2.625 17.8336 2.71719 18.0562 2.88128 18.2203C3.04538 18.3844 3.26794 18.4766 3.5 18.4766H14C14.2321 18.4766 14.4546 18.3844 14.6187 18.2203C14.7828 18.0562 14.875 17.8336 14.875 17.6016V13.2266C14.875 12.9945 14.7828 12.7719 14.6187 12.6078C14.4546 12.4437 14.2321 12.3516 14 12.3516H2.625",
    stroke: "#67768E",
    strokeWidth: 1.03313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIntegration);
export default __webpack_public_path__ + "static/media/APIIntegration.033327265fdcdb64ce5347b623e77805.svg";
export { ForwardRef as ReactComponent };